import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const PCPM = () => {
  const data = [
    ['Month', 'Revenue'],
    ['January', 2.8],
    ['February', 3.0],
    ['March', 2.5],
    ['April', 3.2],
    ['May', 2.9],
  ];

  const options = {
    title: 'Per Capita Per Month (PCPM)',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Revenue (in Lakhs)' },
    legend: { position: 'top' },
    curveType: 'function',
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="LineChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default PCPM;